export default __webpack_public_path__ + "static/media/no-property-nobg.73b92953.svg";